export const sectionIds = [
  'Startseite',
  'Features',
  'dienstleistungen',
  'referenzen',
  'Release Notes',
  'Lizenz',
];
